import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "px-0 py-3 sm:px-6 lg:col-span-3 lg:px-0 lg:py-0" }
const _hoisted_3 = { class: "space-y-1 sticky top-20" }
const _hoisted_4 = ["href", "onClick", "aria-current"]
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = {
  key: 0,
  class: "space-y-6 sm:px-6 lg:col-span-7 lg:px-0"
}
const _hoisted_7 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_8 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_9 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_10 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_11 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_12 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_13 = {
  for: "name",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_14 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "name-error"
}
const _hoisted_16 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_17 = {
  for: "date",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "date-error"
}
const _hoisted_20 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_21 = { class: "flex justify-between items-center" }
const _hoisted_22 = {
  for: "slug",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_23 = ["data-clipboard-text"]
const _hoisted_24 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_25 = { class: "shrink-0 text-base text-gray-500 select-none sm:text-sm/6" }
const _hoisted_26 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "slug-error"
}
const _hoisted_27 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_28 = {
  for: "language",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_29 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_30 = { value: "uk" }
const _hoisted_31 = { value: "en" }
const _hoisted_32 = { value: "pl" }
const _hoisted_33 = { value: "es" }
const _hoisted_34 = { value: "de" }
const _hoisted_35 = { value: "fr" }
const _hoisted_36 = { value: "it" }
const _hoisted_37 = { value: "cz" }
const _hoisted_38 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "language-error"
}
const _hoisted_39 = { class: "col-span-6" }
const _hoisted_40 = { class: "flex gap-3" }
const _hoisted_41 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_42 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_43 = { class: "text-sm/6" }
const _hoisted_44 = {
  for: "top_button_enabled",
  class: "font-medium text-gray-900"
}
const _hoisted_45 = {
  id: "top_button_enabled-description",
  class: "text-gray-500"
}
const _hoisted_46 = { class: "col-span-6" }
const _hoisted_47 = { class: "flex gap-3" }
const _hoisted_48 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_49 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_50 = { class: "text-sm/6" }
const _hoisted_51 = {
  for: "allow_caption",
  class: "font-medium text-gray-900"
}
const _hoisted_52 = {
  id: "allow_caption-description",
  class: "text-gray-500"
}
const _hoisted_53 = { class: "col-span-6" }
const _hoisted_54 = { class: "flex gap-3" }
const _hoisted_55 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_56 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_57 = { class: "text-sm/6" }
const _hoisted_58 = {
  for: "allow_tutorial",
  class: "font-medium text-gray-900"
}
const _hoisted_59 = {
  id: "allow_tutorial-description",
  class: "text-gray-500"
}
const _hoisted_60 = { class: "col-span-6" }
const _hoisted_61 = { class: "flex gap-3" }
const _hoisted_62 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_63 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_64 = { class: "text-sm/6" }
const _hoisted_65 = {
  for: "autoplay_video",
  class: "font-medium text-gray-900"
}
const _hoisted_66 = {
  id: "autoplay_video-description",
  class: "text-gray-500"
}
const _hoisted_67 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_68 = { class: "flex gap-3" }
const _hoisted_69 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_70 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "text-sm/6" }
const _hoisted_73 = {
  for: "face_grouping_enabled",
  class: "font-medium text-gray-900 inline-flex items-center gap-1.5"
}
const _hoisted_74 = {
  id: "face_grouping_enabled-description",
  class: "text-gray-500"
}
const _hoisted_75 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_76 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_77 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_78 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_79 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_80 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_81 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_82 = { class: "col-span-6" }
const _hoisted_83 = { class: "flex gap-3" }
const _hoisted_84 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_85 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_86 = { class: "text-sm/6" }
const _hoisted_87 = {
  for: "allow_all_photos",
  class: "font-medium text-gray-900"
}
const _hoisted_88 = {
  id: "allow_all_photos-description",
  class: "text-gray-500"
}
const _hoisted_89 = { class: "col-span-6" }
const _hoisted_90 = { class: "flex gap-3" }
const _hoisted_91 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_92 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_93 = { class: "text-sm/6" }
const _hoisted_94 = {
  for: "allow_empty_folders",
  class: "font-medium text-gray-900"
}
const _hoisted_95 = {
  id: "allow_empty_folders-description",
  class: "text-gray-500"
}
const _hoisted_96 = { class: "col-span-6" }
const _hoisted_97 = { class: "flex gap-3" }
const _hoisted_98 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_99 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_100 = { class: "text-sm/6" }
const _hoisted_101 = {
  for: "allow_list_view",
  class: "font-medium text-gray-900"
}
const _hoisted_102 = {
  id: "allow_list_view-description",
  class: "text-gray-500"
}
const _hoisted_103 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_104 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_105 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_106 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_107 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_108 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_109 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_110 = { class: "col-span-6" }
const _hoisted_111 = { class: "flex gap-3" }
const _hoisted_112 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_113 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_114 = { class: "text-sm/6" }
const _hoisted_115 = {
  for: "allow_favorite",
  class: "font-medium text-gray-900"
}
const _hoisted_116 = {
  id: "allow_favorite-description",
  class: "text-gray-500"
}
const _hoisted_117 = { class: "col-span-6" }
const _hoisted_118 = { class: "flex gap-3" }
const _hoisted_119 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_120 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_121 = { class: "text-sm/6" }
const _hoisted_122 = {
  for: "is_need_to_finish_favorites",
  class: "font-medium text-gray-900"
}
const _hoisted_123 = {
  id: "is_need_to_finish_favorites-description",
  class: "text-gray-500"
}
const _hoisted_124 = { class: "col-span-6" }
const _hoisted_125 = { class: "flex gap-3" }
const _hoisted_126 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_127 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_128 = { class: "text-sm/6" }
const _hoisted_129 = {
  for: "allow_limit_favorites",
  class: "font-medium text-gray-900"
}
const _hoisted_130 = {
  id: "allow_limit_favorites-description",
  class: "text-gray-500"
}
const _hoisted_131 = ["max"]
const _hoisted_132 = {
  key: 0,
  class: "grid sm:hidden sm:grid-cols-3 sm:items-start sm:gap-4 py-1 sm:py-3"
}
const _hoisted_133 = {
  for: "limit_favorites",
  class: "block text-sm/6 font-medium text-gray-900 sm:pt-1.5"
}
const _hoisted_134 = { class: "mt-2 sm:col-span-2 sm:mt-0" }
const _hoisted_135 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_136 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_137 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_138 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_139 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_140 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_141 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_142 = { class: "col-span-6" }
const _hoisted_143 = { class: "flex gap-3" }
const _hoisted_144 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_145 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_146 = { class: "text-sm/6" }
const _hoisted_147 = {
  for: "allow_download",
  class: "font-medium text-gray-900"
}
const _hoisted_148 = {
  id: "allow_download-description",
  class: "text-gray-500"
}
const _hoisted_149 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_150 = { class: "rounded-md bg-yellow-50 p-4" }
const _hoisted_151 = { class: "flex" }
const _hoisted_152 = { class: "shrink-0" }
const _hoisted_153 = { class: "ml-3" }
const _hoisted_154 = { class: "text-sm font-medium text-yellow-800" }
const _hoisted_155 = { class: "mt-2 text-sm text-yellow-700" }
const _hoisted_156 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_157 = { class: "flex justify-between items-center" }
const _hoisted_158 = {
  for: "storage_to_date",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_159 = { class: "mt-2" }
const _hoisted_160 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "storage_to_date-error"
}
const _hoisted_161 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_162 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_163 = { class: "inline-flex justify-between w-full" }
const _hoisted_164 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_165 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_166 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_167 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_168 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_169 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_170 = { class: "col-span-6" }
const _hoisted_171 = { class: "flex gap-3" }
const _hoisted_172 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_173 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_174 = { class: "text-sm/6" }
const _hoisted_175 = {
  for: "is_public",
  class: "font-medium text-gray-900"
}
const _hoisted_176 = {
  id: "is_public-description",
  class: "text-gray-500"
}
const _hoisted_177 = {
  key: 0,
  class: "col-span-6 sm:col-span-6"
}
const _hoisted_178 = { class: "flex justify-between items-center" }
const _hoisted_179 = {
  for: "storage_to_date",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_180 = ["data-clipboard-text"]
const _hoisted_181 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_182 = { class: "flex" }
const _hoisted_183 = { class: "-mr-px grid grow grid-cols-1 focus-within:relative" }
const _hoisted_184 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "storage_to_date-error"
}
const _hoisted_185 = {
  key: 1,
  class: "col-span-6 sm:col-span-6"
}
const _hoisted_186 = { class: "flex gap-3" }
const _hoisted_187 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_188 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_189 = { class: "text-sm/6" }
const _hoisted_190 = {
  for: "allow_photo_hiding",
  class: "font-medium text-gray-900"
}
const _hoisted_191 = {
  id: "allow_photo_hiding-description",
  class: "text-gray-500"
}
const _hoisted_192 = {
  key: 2,
  class: "col-span-6 sm:col-span-6"
}
const _hoisted_193 = {
  for: "photo_hiding_client_email",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_194 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_195 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "photo_hiding_client_email-error"
}
const _hoisted_196 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_197 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_198 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_SparklesIcon = _resolveComponent("SparklesIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GalleryStatisticsComponent = _resolveComponent("GalleryStatisticsComponent")!
  const _component_ArrowPathRoundedSquareIcon = _resolveComponent("ArrowPathRoundedSquareIcon")!
  const _component_DeleteGalleryConfirmationModalComponent = _resolveComponent("DeleteGalleryConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ControlsMenuComponent, { class: "sm:mb-6" }),
        _createElementVNode("aside", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNavigation, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                key: item.name,
                href: `#${item.id}`,
                onClick: _withModifiers(($event: any) => (_ctx.currentSection = item.id), ["prevent"]),
                class: _normalizeClass([_ctx.currentSection == item.id ? 'bg-white text-blue-600 hover:bg-white' : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-3 py-2 text-sm font-medium']),
                "aria-current": _ctx.currentSection == item.id ? 'page' : undefined
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                  class: _normalizeClass([_ctx.currentSection == item.id ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 -ml-1 size-6 shrink-0']),
                  "aria-hidden": "true"
                }, null, 8, ["class"])),
                _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
                (item.id == 'savings' && _ctx.isCurrentGallery && _ctx.gallery.is_expired_storage)
                  ? (_openBlock(), _createBlock(_component_ExclamationTriangleIcon, {
                      key: 0,
                      class: "ml-auto size-4 text-red-600"
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]),
        (_ctx.isCurrentGallery)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.currentSection == 'main')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('gallery_settings.general.title')), 1),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('gallery_settings.general.tip')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('gallery_settings.general.name')), 1),
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                id: "name",
                                name: "name",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                                type: "text",
                                autocomplete: "name",
                                class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('name')
                                        })
                              }, null, 2), [
                                [_vModelText, _ctx.form.name]
                              ]),
                              (_ctx.hasError('name'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('name'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.getError('name')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('gallery_settings.general.date')), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_DatePickerComponent, {
                                id: "date",
                                modelValue: _ctx.form.date,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date) = $event)),
                                error: _ctx.hasError('date'),
                                placeholder: _ctx.$t('gallery_settings.general.date')
                              }, null, 8, ["modelValue", "error", "placeholder"])
                            ]),
                            (_ctx.hasError('date'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.getError('date')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('gallery_settings.general.address')), 1),
                              _createElementVNode("a", {
                                href: "#",
                                "data-clipboard-text": _ctx.gallery.public_url,
                                class: "text-sm/4 text-gray-400 hover:text-gray-500 hover:underline btn-copy"
                              }, _toDisplayString(_ctx.$t('gallery_settings.general.copy')), 9, _hoisted_23)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", {
                                class: _normalizeClass({
                                            'flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600': true,
                                            'col-start-1 row-start-1 block w-full rounded-md text-base text-red-900 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus-within:outline-red-600 sm:text-sm/6': _ctx.hasError('slug')
                                        })
                              }, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.gallery.public_url.replace(_ctx.gallery.slug, '').replace('https://', '')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "slug",
                                  id: "slug",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.slug) = $event)),
                                  class: _normalizeClass({
                                                'block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6': true,
                                                'text-red-900': _ctx.hasError('slug')
                                            }),
                                  placeholder: "some-photos"
                                }, null, 2), [
                                  [_vModelText, _ctx.form.slug]
                                ]),
                                (_ctx.hasError('slug'))
                                  ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                      key: 0,
                                      class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                      "aria-hidden": "true"
                                    }))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            (_ctx.hasError('slug'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.getError('slug')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('gallery_settings.general.language')), 1),
                            _createElementVNode("div", _hoisted_29, [
                              _withDirectives(_createElementVNode("select", {
                                id: "language",
                                name: "language",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.language) = $event)),
                                class: _normalizeClass({
                                                'col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                                'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('language')
                                            })
                              }, [
                                _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('gallery_settings.general.languages.ukrainian')), 1),
                                _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('gallery_settings.general.languages.english')), 1),
                                _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t('gallery_settings.general.languages.polish')), 1),
                                _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t('gallery_settings.general.languages.spanish')), 1),
                                _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t('gallery_settings.general.languages.german')), 1),
                                _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t('gallery_settings.general.languages.french')), 1),
                                _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t('gallery_settings.general.languages.italian')), 1),
                                _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.$t('gallery_settings.general.languages.czech')), 1)
                              ], 2), [
                                [_vModelSelect, _ctx.form.language]
                              ]),
                              _createVNode(_component_ChevronDownIcon, {
                                class: "pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                "aria-hidden": "true"
                              }),
                              (_ctx.hasError('language'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('language'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.getError('language')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "top_button_enabled",
                                    "aria-describedby": "top_button_enabled-description",
                                    name: "top_button_enabled",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.top_button_enabled) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.top_button_enabled]
                                  ]),
                                  _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('gallery_settings.general.top_button')), 1),
                                _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('gallery_settings.general.top_button_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_caption",
                                    "aria-describedby": "allow_caption-description",
                                    name: "allow_caption",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.allow_caption) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_caption]
                                  ]),
                                  _cache[33] || (_cache[33] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('gallery_settings.general.photo_caption')), 1),
                                _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('gallery_settings.general.photo_caption_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", _hoisted_56, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_tutorial",
                                    "aria-describedby": "allow_tutorial-description",
                                    name: "allow_tutorial",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.allow_tutorial) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_tutorial]
                                  ]),
                                  _cache[34] || (_cache[34] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('gallery_settings.general.tutorial')), 1),
                                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('gallery_settings.general.tutorial_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "autoplay_video",
                                    "aria-describedby": "autoplay_video-description",
                                    name: "autoplay_video",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.autoplay_video) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.autoplay_video]
                                  ]),
                                  _cache[35] || (_cache[35] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('gallery_settings.general.autoplay_video')), 1),
                                _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$t('gallery_settings.general.autoplay_video_tip')), 1)
                              ])
                            ])
                          ]),
                          (_ctx.form.face_grouping_visible)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _withDirectives(_createElementVNode("input", {
                                        id: "face_grouping_enabled",
                                        "aria-describedby": "face_grouping_enabled-description",
                                        name: "face_grouping_enabled",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.face_grouping_enabled) = $event)),
                                        disabled: !_ctx.form.face_grouping_available,
                                        class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                      }, null, 8, _hoisted_71), [
                                        [_vModelCheckbox, _ctx.form.face_grouping_enabled]
                                      ]),
                                      _cache[36] || (_cache[36] = _createElementVNode("svg", {
                                        class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                        viewBox: "0 0 14 14",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          class: "opacity-0 group-has-checked:opacity-100",
                                          d: "M3 8L6 11L11 3.5",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }),
                                        _createElementVNode("path", {
                                          class: "opacity-0 group-has-indeterminate:opacity-100",
                                          d: "M3 7H11",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        })
                                      ], -1))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("label", _hoisted_73, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('gallery_settings.general.face_grouping')) + " ", 1),
                                      _createVNode(_component_SparklesIcon, {
                                        class: "w-4 h-4 text-royal-blue-600",
                                        "aria-label": "AI"
                                      })
                                    ]),
                                    _createElementVNode("p", _hoisted_74, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('gallery_settings.general.face_grouping_tip')) + " ", 1),
                                      (!_ctx.form.face_grouping_available)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('gallery_settings.general.face_grouping_plan_required')) + " ", 1),
                                            _createVNode(_component_router_link, {
                                              to: "/subscription",
                                              class: "text-royal-blue-600 hover:text-royal-blue-700 hover:underline font-medium"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('gallery_settings.general.face_grouping_view_plans')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("button", _hoisted_76, _toDisplayString(_ctx.$t('gallery_settings.save')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.currentSection == 'folders')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_79, _toDisplayString(_ctx.$t('gallery_settings.folders.title')), 1),
                          _createElementVNode("p", _hoisted_80, _toDisplayString(_ctx.$t('gallery_settings.folders.tip_text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("div", _hoisted_85, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_all_photos",
                                    "aria-describedby": "allow_all_photos-description",
                                    name: "allow_all_photos",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.allow_all_photos) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_all_photos]
                                  ]),
                                  _cache[37] || (_cache[37] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('gallery_settings.folders.allow_all_photos')), 1),
                                _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.$t('gallery_settings.folders.allow_all_photos_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_empty_folders",
                                    "aria-describedby": "allow_empty_folders-description",
                                    name: "allow_empty_folders",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.allow_empty_folders) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_empty_folders]
                                  ]),
                                  _cache[38] || (_cache[38] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('gallery_settings.folders.empty_folders')), 1),
                                _createElementVNode("p", _hoisted_95, _toDisplayString(_ctx.$t('gallery_settings.folders.empty_folders_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("div", _hoisted_99, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_list_view",
                                    "aria-describedby": "allow_list_view-description",
                                    name: "allow_list_view",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.allow_list_view) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_list_view]
                                  ]),
                                  _cache[39] || (_cache[39] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t('gallery_settings.folders.allow_list_view')), 1),
                                _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.$t('gallery_settings.folders.allow_list_view_tip')), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("button", _hoisted_104, _toDisplayString(_ctx.$t('gallery_settings.save')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.currentSection == 'favorites')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 2,
                    onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_107, _toDisplayString(_ctx.$t('gallery_settings.favorites.title')), 1),
                          _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.$t('gallery_settings.favorites.tip_text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("div", _hoisted_112, [
                                _createElementVNode("div", _hoisted_113, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_favorite",
                                    "aria-describedby": "allow_all_photos-description",
                                    name: "allow_favorite",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.allow_favorite) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_favorite]
                                  ]),
                                  _cache[40] || (_cache[40] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('gallery_settings.favorites.allow_favorite')), 1),
                                _createElementVNode("p", _hoisted_116, _toDisplayString(_ctx.$t('gallery_settings.favorites.allow_favorite_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("div", _hoisted_120, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "is_need_to_finish_favorites",
                                    "aria-describedby": "is_need_to_finish_favorites-description",
                                    name: "is_need_to_finish_favorites",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.is_need_to_finish_favorites) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.is_need_to_finish_favorites]
                                  ]),
                                  _cache[41] || (_cache[41] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t('gallery_settings.favorites.is_need_to_finish_favorites')), 1),
                                _createElementVNode("p", _hoisted_123, _toDisplayString(_ctx.$t('gallery_settings.favorites.is_need_to_finish_favorites_tip')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_limit_favorites",
                                    "aria-describedby": "allow_limit_favorites-description",
                                    name: "allow_limit_favorites",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.allow_limit_favorites) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_limit_favorites]
                                  ]),
                                  _cache[42] || (_cache[42] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('gallery_settings.favorites.allow_limit_favorites')), 1),
                                _createElementVNode("p", _hoisted_130, _toDisplayString(_ctx.$t('gallery_settings.favorites.allow_limit_favorites_tip')), 1)
                              ]),
                              (_ctx.form.allow_limit_favorites)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "number",
                                    name: "limit_favorites",
                                    id: "limit_favorites",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.limit_favorites) = $event)),
                                    min: "0",
                                    max: _ctx.gallery.photos_count,
                                    class: "hidden sm:block w-16 ms-auto text-center rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                                  }, null, 8, _hoisted_131)), [
                                    [_vModelText, _ctx.form.limit_favorites]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.form.allow_limit_favorites)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                  _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.$t('gallery_settings.favorites.allow_limit_favorites_count')), 1),
                                  _createElementVNode("div", _hoisted_134, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      name: "limit_favorites",
                                      id: "limit_favorites",
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.limit_favorites) = $event)),
                                      class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                                    }, null, 512), [
                                      [_vModelText, _ctx.form.limit_favorites]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("button", _hoisted_136, _toDisplayString(_ctx.$t('gallery_settings.save')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.currentSection == 'savings')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 3,
                    onSubmit: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_139, _toDisplayString(_ctx.$t('gallery_settings.savings.title')), 1),
                          _createElementVNode("p", _hoisted_140, _toDisplayString(_ctx.$t('gallery_settings.savings.tip_text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", _hoisted_142, [
                            _createElementVNode("div", _hoisted_143, [
                              _createElementVNode("div", _hoisted_144, [
                                _createElementVNode("div", _hoisted_145, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "allow_download",
                                    "aria-describedby": "allow_download-description",
                                    name: "allow_download",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.allow_download) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.allow_download]
                                  ]),
                                  _cache[43] || (_cache[43] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t('gallery_settings.savings.allow_download')), 1),
                                _createElementVNode("p", _hoisted_148, _toDisplayString(_ctx.$t('gallery_settings.savings.allow_download_tip')), 1)
                              ])
                            ])
                          ]),
                          (_ctx.gallery.is_expired_storage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                _createElementVNode("div", _hoisted_150, [
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("div", _hoisted_152, [
                                      _createVNode(_component_ExclamationTriangleIcon, {
                                        class: "size-5 text-yellow-400",
                                        "aria-hidden": "true"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_153, [
                                      _createElementVNode("h3", _hoisted_154, _toDisplayString(_ctx.$t('gallery_settings.savings.is_expired_storage')), 1),
                                      _createElementVNode("div", _hoisted_155, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('gallery_settings.savings.is_expired_storage_tip')), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_156, [
                            _createElementVNode("div", _hoisted_157, [
                              _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('gallery_settings.savings.storage_to')), 1),
                              (_ctx.form.storage_to_date !== null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetStorageToDate && _ctx.resetStorageToDate(...args)), ["prevent"])),
                                    class: "text-sm/4 text-gray-400 hover:text-gray-500 hover:underline cursor-pointer"
                                  }, _toDisplayString(_ctx.$t('gallery_settings.savings.unlimited_storage')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_159, [
                              _createVNode(_component_DatePickerComponent, {
                                id: "storage_to_date",
                                modelValue: _ctx.form.storage_to_date,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.storage_to_date) = $event)),
                                error: _ctx.hasError('storage_to_date'),
                                min: _ctx.todayIso,
                                placeholder: _ctx.$t('gallery_settings.savings.storage_to'),
                                "empty-label": _ctx.$t('gallery_settings.savings.unlimited_storage')
                              }, null, 8, ["modelValue", "error", "min", "placeholder", "empty-label"])
                            ]),
                            (_ctx.hasError('storage_to_date'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_160, _toDisplayString(_ctx.getError('storage_to_date')), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_161, _toDisplayString(_ctx.$t('gallery_settings.savings.storage_to_tip')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_162, [
                        _createElementVNode("div", _hoisted_163, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteGallery && _ctx.deleteGallery(...args)), ["prevent"])),
                            class: "inline-flex justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-600 focus:outline-hidden cursor-pointer"
                          }, _toDisplayString(_ctx.$t('gallery_settings.savings.delete_gallery')), 1),
                          _createElementVNode("button", _hoisted_164, _toDisplayString(_ctx.$t('gallery_settings.save')), 1)
                        ])
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.currentSection == 'statistics')
                ? (_openBlock(), _createBlock(_component_GalleryStatisticsComponent, {
                    key: 4,
                    gallery: _ctx.gallery
                  }, null, 8, ["gallery"]))
                : _createCommentVNode("", true),
              (_ctx.currentSection == 'access')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 5,
                    onSubmit: _cache[30] || (_cache[30] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_167, _toDisplayString(_ctx.$t('gallery_settings.access.title')), 1),
                          _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.$t('gallery_settings.access.tip_text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _createElementVNode("div", _hoisted_172, [
                                _createElementVNode("div", _hoisted_173, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "is_public",
                                    "aria-describedby": "allow_download-description",
                                    name: "is_public",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.is_public) = $event)),
                                    class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.is_public]
                                  ]),
                                  _cache[44] || (_cache[44] = _createElementVNode("svg", {
                                    class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                                    viewBox: "0 0 14 14",
                                    fill: "none"
                                  }, [
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-checked:opacity-100",
                                      d: "M3 8L6 11L11 3.5",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-0 group-has-indeterminate:opacity-100",
                                      d: "M3 7H11",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_174, [
                                _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.$t('gallery_settings.access.is_public')), 1),
                                _createElementVNode("p", _hoisted_176, _toDisplayString(_ctx.$t('gallery_settings.access.is_public_tip')), 1)
                              ])
                            ])
                          ]),
                          (!_ctx.form.is_public)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                _createElementVNode("div", _hoisted_178, [
                                  _createElementVNode("label", _hoisted_179, _toDisplayString(_ctx.$t('gallery_settings.access.password')), 1),
                                  _createElementVNode("span", {
                                    "data-clipboard-text": _ctx.form.password,
                                    class: "text-sm/4 text-gray-400 hover:text-gray-500 hover:underline cursor-pointer btn-copy"
                                  }, _toDisplayString(_ctx.$t('gallery_settings.access.copy')), 9, _hoisted_180)
                                ]),
                                _createElementVNode("div", _hoisted_181, [
                                  _createElementVNode("div", _hoisted_182, [
                                    _createElementVNode("div", _hoisted_183, [
                                      _withDirectives(_createElementVNode("input", {
                                        id: "password",
                                        name: "password",
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.password) = $event)),
                                        type: "text",
                                        autocomplete: "password",
                                        class: _normalizeClass({
                                                        'block w-full rounded-l-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                                        'col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('storage_to_date')
                                                    })
                                      }, null, 2), [
                                        [_vModelText, _ctx.form.password]
                                      ])
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.generatePassword && _ctx.generatePassword(...args))),
                                      class: "flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 cursor-pointer"
                                    }, [
                                      _createVNode(_component_ArrowPathRoundedSquareIcon, {
                                        class: "-ml-0.5 size-4",
                                        "aria-hidden": "true"
                                      })
                                    ])
                                  ]),
                                  (_ctx.hasError('password'))
                                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                        key: 0,
                                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                        "aria-hidden": "true"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.hasError('password'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_184, _toDisplayString(_ctx.getError('password')), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.form.config.hide_photos)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                _createElementVNode("div", _hoisted_186, [
                                  _createElementVNode("div", _hoisted_187, [
                                    _createElementVNode("div", _hoisted_188, [
                                      _withDirectives(_createElementVNode("input", {
                                        id: "allow_photo_hiding",
                                        "aria-describedby": "allow_photo_hiding-description",
                                        name: "allow_photo_hiding",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.allow_photo_hiding) = $event)),
                                        class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-indigo-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.form.allow_photo_hiding]
                                      ]),
                                      _cache[45] || (_cache[45] = _createElementVNode("svg", {
                                        class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-checked:opacity-100",
                                        viewBox: "0 0 14 14",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          class: "opacity-0 group-has-checked:opacity-100",
                                          d: "M3 8L6 11L11 3.5",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }),
                                        _createElementVNode("path", {
                                          class: "opacity-0 group-has-indeterminate:opacity-100",
                                          d: "M3 7H11",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        })
                                      ], -1))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_189, [
                                    _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.$t('gallery_settings.access.photo_hiding')), 1),
                                    _createElementVNode("p", _hoisted_191, _toDisplayString(_ctx.$t('gallery_settings.access.photo_hiding_tip')), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.form.allow_photo_hiding)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                                _createElementVNode("label", _hoisted_193, _toDisplayString(_ctx.$t('gallery_settings.access.client_email')), 1),
                                _createElementVNode("div", _hoisted_194, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "photo_hiding_client_email",
                                    name: "photo_hiding_client_email",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.photo_hiding_client_email) = $event)),
                                    type: "email",
                                    autocomplete: "email",
                                    class: _normalizeClass({
                                                'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                                'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('photo_hiding_client_email')
                                            }),
                                    placeholder: "client@example.com"
                                  }, null, 2), [
                                    [_vModelText, _ctx.form.photo_hiding_client_email]
                                  ]),
                                  (_ctx.hasError('photo_hiding_client_email'))
                                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                        key: 0,
                                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                        "aria-hidden": "true"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.hasError('photo_hiding_client_email'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_195, _toDisplayString(_ctx.getError('photo_hiding_client_email')), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_196, _toDisplayString(_ctx.$t('gallery_settings.access.client_email_tip')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_197, [
                        _createElementVNode("button", _hoisted_198, _toDisplayString(_ctx.$t('gallery_settings.save')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DeleteGalleryConfirmationModalComponent, {
      open: _ctx.isDeletingConfirmation,
      onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isDeletingConfirmation = false)),
      onConfirmAction: _ctx.doDeleteGallery,
      title: _ctx.$t('gallery_settings.delete_gallery.title'),
      message: _ctx.$t('gallery_settings.delete_gallery.confirmation'),
      secondMessage: _ctx.deletingConfirmationWarning,
      buttonText: _ctx.$t('gallery_settings.delete_gallery.button')
    }, null, 8, ["open", "onConfirmAction", "title", "message", "secondMessage", "buttonText"])
  ], 64))
}